import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import config from 'config'
import { detectLanguage } from '../helpers/functions'

const language = detectLanguage()

function _genericCatch() {
	//console.log(err)
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function getCartData() {
	return http_agent.post(config.services + 'service.php')
		.send({
			method: 'getCart',
			language,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function addToCart(entityUID, entityType, libraryUID) {
	const params = {
		method: 'addToCart',
		entityUID,
		entityType,
	}
	if (libraryUID) {
		params.privateLibraryId = libraryUID
	}
	return http_agent.post(config.services + 'service.php')
		.send(params)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function removeFromCart(entityUID, entityType) {
	return http_agent.post(config.services + 'service.php')
		.send({
			method: 'removeFromCart',
			entityUID,
			entityType,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function downloadProduct(entityUID, entityType, libraryUID) {
	const bundleValue = entityType === 'B' ? '1':'0'
	const params = {
		method: 'downloadFeatured',
		presentation_uid: entityUID,
		isBundle: bundleValue,
		/*userId: userId*/
	}
	if (libraryUID) {
		params.privateLibraryId = libraryUID
	}
	return http_agent.post(config.services + 'service.php')
		.send(params)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const responseData = JSON.parse(response.text)
			return responseData
		})
	//"method=downloadFeatured&userId="+userSv.getUserData().payload.userId+"&presentation_uid="+id+"&isBundle="+bundleValue
}

export default {
	getCartData,
	addToCart,
	removeFromCart,
	downloadProduct,
}
